export default __webpack_public_path__ + "static/media/Affogato-Scroll.3468533f.png";